import projectsService from '../services/projectsService';

export const fetchAllProjects = async (params) => {
  const result = await projectsService.getAllProjects(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Projeler alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchProjectById = async (id) => {
  const result = await projectsService.getProjectById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createProject = async (payload, coverImage) => {
  const result = await projectsService.createProject(payload, coverImage);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateProject = async (payload) => {
  const result = await projectsService.updateProject(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteProject = async (id) => {
  const result = await projectsService.deleteProject(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderProjects = async (projectIdsInOrder) => {
  const result = await projectsService.reorderProjects({ projectIdsInOrder });
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje sıralaması güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const uploadProjectCoverImage = async ({ projectId, file }) => {
  const result = await projectsService.uploadProjectCoverImage({ projectId, file });
  if (!result?.success) {
    const error = new Error(result?.message || 'Kapak görseli yüklenemedi');
    error.details = result;
    throw error;
  }
  // returns cover image url string
  return result.data;
};

export const uploadProjectImage = async ({ projectId, file }) => {
  const result = await projectsService.uploadProjectImage({ projectId, file });
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje görseli yüklenemedi');
    error.details = result;
    throw error;
  }
  // returns ProjectImageDto
  return result.data;
};

export const reorderProjectImages = async ({ projectId, imageIdsInOrder }) => {
  const result = await projectsService.reorderProjectImages({ projectId, imageIdsInOrder });
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje görselleri sıralanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeProjectImage = async ({ projectId, imageId }) => {
  const result = await projectsService.removeProjectImage({ projectId, imageId });
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje görseli kaldırılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const addProjectMember = async (payload) => {
  const result = await projectsService.addProjectMember(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üye eklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeProjectMember = async (payload) => {
  const result = await projectsService.removeProjectMember(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Üye kaldırılamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const setProjectLeader = async (payload) => {
  const result = await projectsService.setProjectLeader(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Proje lideri belirlenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAllProjects,
  fetchProjectById,
  createProject,
  updateProject,
  deleteProject,
  reorderProjects,
  uploadProjectCoverImage,
  uploadProjectImage,
  reorderProjectImages,
  removeProjectImage,
  addProjectMember,
  removeProjectMember,
  setProjectLeader,
};

